import withDisplayName from 'bz-utilities/hoc/display-name';
import useComputed from 'bz-utilities/hooks/computed';
import { observer } from 'mobx-react';
import type React from 'react';

import { cache } from 'tm3-core/cache';

const ShellMarketing = observer(
  withDisplayName((props) => {
    const className = useComputed(() => {
      const classNames = ['login-marketing'];

      if (cache.isProntoPortal) {
        classNames.push('pronto-login');
      }

      return classNames.toClassNames();
    }, []);

    const style = useComputed(() => {
      const style: React.CSSProperties = {};

      if (cache.isProntoPortal) {
        style.backgroundImage = 'url(/images/pronto-login-back.webp)';
      } else if (cache.app.Caseflow) {
        style.backgroundImage = 'url(/images/caseflow-login-back.webp)';
      } else if (cache.isEClinic) {
        style.backgroundImage = 'url(/images/eclinic-login-back.webp)';
      } else if (cache.isPPM) {
        style.backgroundImage = 'url(/images/ppm-login-back.webp)';
      } else {
        style.backgroundImage = 'url(/images/tm3-login-back.webp)';
      }

      return style;
    }, []);

    return <div className={className} style={style}></div>;
  }, 'ShellMarketing')
);

export default ShellMarketing;
